// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"123":"b8eb1fb1","124":"f539079a","212":"6e6636ae","538":"f33f33fd","703":"d7183f55","940":"b9a4d512"}[chunkId] + ".chunk.js";
};